export default "__VITE_PUBLIC_ASSET__ad21fd6a__"